angular.module('iqxCore')
.service('ActionDialogLegacySvc', function (FormSvc) {
	var svc=this

  svc.Actions=function(scope, type, SampleSize, obj){
    switch(type){
      case 'show':
        svc.ActionOpts = {
          obj:obj,
          '$form_controller':'ActionDialogLegacyCtrl',
          'SampleSize':SampleSize
        }
        var ActionTemplate = 'actionDialogLegacy.html'
      break

      case 'contactevents':
        svc.ActionOpts = {
          obj:obj,
          '$form_controller':'ActionDialogLegacyContactEventsModalCtrl',
          'SampleSize':SampleSize
        }
        var ActionTemplate = 'actionDialogLegacy.contactEventsModal.html'
      break

      case 'getcontactdetails':
        svc.ActionOpts = {
          obj:obj,
          '$form_controller':'ActionDialogLegacyContactDetailsModalCtrl',
          'SampleSize':SampleSize
        }
        var ActionTemplate = 'actionDialogLegacy.contactDetailsModal.html'
      break

      case 'candidateDocuments':
        svc.ActionOpts = {
          obj:obj,
          '$form_controller':'ActionDialogLegacyCandidateDocumentsCtrl',
          'SampleSize':SampleSize
        }
        var ActionTemplate = 'actionDialogLegacy.candidateDocuments.html'
      break
    }
    return FormSvc.modalForm(scope,ActionTemplate,svc.ActionOpts,'lg',true,scope.tags) 
  }
})
